import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ErrorReportingService, SecurityService } from 'common';
//import { Inject } from '@angular/core';

export function SecurityServiceFactory(document: Document, http: HttpClient, errorReportingService: ErrorReportingService): SecurityService {
  const service = new SecurityService(document, http, errorReportingService);
  service.apiClientType = 'SenderId';
  return service;
}
